// web/src/lib/spam-addresses.ts
//
// T14/T20 — Admin CRUD + bulk import for spam email address patterns
// (`/api/admin/spam-addresses`).
import { get, post, apiFetch } from "./api";

export interface SpamAddress {
  spamEmailAddressId: number;
  pattern: string;
}

export interface SpamImportResult {
  accepted: number;
  rejected: string[];
}

export const spamAddressesApi = {
  list: (): Promise<SpamAddress[]> => get<SpamAddress[]>("/api/admin/spam-addresses"),
  create: (pattern: string): Promise<SpamAddress> =>
    post<SpamAddress>("/api/admin/spam-addresses", { pattern }),
  remove: (id: number): Promise<void> =>
    apiFetch<void>(`/api/admin/spam-addresses/${id}`, { method: "DELETE" }),
  import: (text: string): Promise<SpamImportResult> =>
    post<SpamImportResult>("/api/admin/spam-addresses/import", { text }),
};
